import Joi from '@hapi/joi';

export const verificatieBerekeningUnitUnityCheckSchema = Joi.object().keys({
    id: Joi.string().required(),
    unityCheckType: Joi.string().required(),
    unityCheckTypeAnders: Joi.string().allow(null, ''),
    modelleerNiveau: Joi.string().required(),
    unityCheckScore: Joi.number().required(),
});
